import React, { Fragment } from "react";
import { InspectorControls } from "@wordpress/block-editor";
import { PanelBody } from "@wordpress/components";
import { addFilter } from "@wordpress/hooks";
import { createHigherOrderComponent } from "@wordpress/compose";
import {
    commonAttributes,
    HoverBarControls,
    getHoverBarStyle,
} from "./components/imageComponents";

// Dodajemy nowe atrybuty do bloku Image
const addImageAttributes = (settings) => {
    if (settings.name !== "core/image") {
        return settings;
    }

    return {
        ...settings,
        attributes: {
            ...settings.attributes,
            ...commonAttributes,
        },
    };
};

// Dodajemy kontrolki do panelu inspekcji
const withInspectorControls = createHigherOrderComponent((BlockEdit) => {
    return (props) => {
        if (props.name !== "core/image") {
            return <BlockEdit {...props} />;
        }

        return (
            <Fragment>
                <BlockEdit {...props} />
                <InspectorControls>
                    <PanelBody title="Hover bar" initialOpen={false}>
                        <HoverBarControls
                            attributes={props.attributes}
                            setAttributes={props.setAttributes}
                        />
                    </PanelBody>
                </InspectorControls>
            </Fragment>
        );
    };
}, "withInspectorControls");

// Modyfikujemy wygląd bloku
const modifyFeaturedImageBlock = createHigherOrderComponent(
    (BlockListBlock) => {
        return (props) => {
            if (props.name !== "core/image") {
                return <BlockListBlock {...props} />;
            }

            const { attributes, clientId } = props;
            const { showHoverBar, width, align } = attributes;
            const { key, ...restProps } = props;

            // Przygotowanie stylu dla kontenera
            const containerStyle = {
                width: width ? width : "100%",
                maxWidth: "100%",
                margin: align === "center" ? "0 auto" : undefined,
            };

            return (
                <div
                    key={clientId || key}
                    className="wp-block-post-featured-image"
                    style={containerStyle}
                >
                    <BlockListBlock {...restProps} />
                    {showHoverBar && (
                        <div
                            key={`hover-bar-${clientId}`}
                            className={`hover-bar ${attributes.animation}`}
                            style={getHoverBarStyle(attributes)}
                        />
                    )}
                </div>
            );
        };
    },
    "modifyFeaturedImageBlock"
);

// Rejestrujemy filtry
addFilter(
    "blocks.registerBlockType",
    "kamikaze/image-hover-attributes",
    addImageAttributes
);

addFilter(
    "editor.BlockEdit",
    "kamikaze/image-hover-controls",
    withInspectorControls
);

addFilter(
    "editor.BlockListBlock",
    "kamikaze/image-hover-display",
    modifyFeaturedImageBlock
);

const modifyImageSave = (element, blockType, attributes) => {
    if (blockType.name !== "core/image") {
        return element;
    }

    const { showHoverBar, width, align, animation } = attributes;

    // Przygotowanie stylu dla kontenera
    const containerStyle = {
        width: width || "100%",
        maxWidth: "100%",
        margin: align === "center" ? "0 auto" : undefined,
    };

    return (
        <div className="wp-block-custom-image" style={containerStyle}>
            {element}
            {showHoverBar && (
                <div
                    className={`hover-bar ${animation}`}
                    style={getHoverBarStyle(attributes)}
                />
            )}
        </div>
    );
};

addFilter(
    "blocks.getSaveElement",
    "kamikaze/image-hover-save",
    modifyImageSave
);
